import React, { useContext, useState } from 'react'
import { useLocation } from "react-router-dom";
// import response from './confi.json'
// import veevaData from '../../config/veevaVendorResponse.json'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Backdrop,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import ProfileIcon from '../shared/ProfileIcon'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import FileDownloadIcon from "@mui/icons-material/Download";
import popUpMessages from "../../config/popUpMsg.json";
import { formatPopupMessage } from "../shared/util";
import { DirectionContext } from '../../context/DirectionProvider'
import ProgressBar from '../progress/progressBar'
import api from "../../service/api";

const IqviaHcoResponse = (props) => {
  const location = useLocation();
  const response = props.data ?? []
  const [expanded, setExpanded] = useState([])
  const [open, setOpen] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [entity, setEntity] = useState();
  const [popUpMessage, setPopUpMessage] = useState({ heading: "", message: "" });
  const [popMsg] = useState(popUpMessages?.vendorSearch);
  const [subscribeData, setSubscribeData] = useState({});
  const direction = useContext(DirectionContext);

  const handleClick = panel => {
    if (expanded[panel]) {
      setExpanded({
        ...expanded,
        [panel]: false
      })
    } else {
      setExpanded({
        ...expanded,
        [panel]: true
      })
    }
  }

  const subcribeProfile = (rowdata, event) => {
    event.stopPropagation();
    setPopUpMessage({
      heading: popMsg[0].subscribeConfirmation.heading,
      message: popMsg[0].subscribeConfirmation.description,
      cancel: "Cancel",
      onOk: "Confirm",
    });
    setShowPopUp(true);
    const data = {
      onekeyEid: rowdata.workplaceEid,
      entityType: "workplace",
      country: rowdata.country ?? location?.state?.seletedCountry,
      vendor: props.vendor,
      record:{ "individual": {}, "workplace": [rowdata]}
      // firstName: rowdata.individual.firstName,
      // lastName: rowdata.individual.lastName,
    }
    setSubscribeData(data);
  }


  const onCancel = () => {
    setShowPopUp(false);
    setPopUpMessage({});
  }

  const onOk = () => {
    setShowPopUp(false);
    setOpen(true);
    let msgErrorID = subscribeData?.onekeyEid;
    api
      .subscribeProfile(subscribeData)
      .then((res) => {
        if (res.data.eph_profile_flag == true) {
          var reference_Id = res?.data?.ReferenceId;

          setOpen(false);
          setPopUpMessage({
            heading: popMsg[0].profileAlreadyExists.heading,
            message: popMsg[0].profileAlreadyExists.description.replace(/{{msgErrorID}}/g, msgErrorID).replace(/{{reference_Id}}/g, reference_Id),
            cancel: "Close",
          });
          setShowPopUp(true);
        } else {
          setEntity(subscribeData?.onekeyEid);
          let isShellProfileCreated = res?.data?.ShellProfileStatus;
          let shellProfileInfo =  res?.data?.ShellProfileCreationMessage;
          let responseMsg = popMsg[0].subscribeSuccess.description.replace(/{{msgErrorID}}/g, msgErrorID) + (shellProfileInfo ? `\n\n${shellProfileInfo}` : '');
          setPopUpMessage({
            heading: popMsg[0].subscribeSuccess.heading,
            message: responseMsg,
            cancel: "Close",
          });
          setOpen(false);
          setShowPopUp(true);
        }
      })
      .catch((error) => {
        setOpen(false);
        setPopUpMessage({
          heading: popMsg[0].subscribeFailure.heading,
          message: popMsg[0].subscribeFailure.description.replace(/{{msgErrorID}}/g, msgErrorID),
          cancel: "Close",
        });
        setShowPopUp(true);
      });
  }

  return (
    <>


      {
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          {" "}
          <ProgressBar />{" "}
        </Backdrop>
      }
      {showPopUp && (
        <div>
          <Dialog open={true} aria-labelledby="customized-dialog-title">
            <DialogTitle className="_wg-dynamic-text">{popUpMessage.heading}</DialogTitle>

            {popUpMessage.message && (
              <DialogContent dividers>
                <Typography className="_wg-dynamic-text" gutterBottom>
                  {formatPopupMessage(popUpMessage.message, direction)}
                </Typography>
              </DialogContent>
            )}

            <DialogActions sx={{ mr: "15px" }}>
              {popUpMessage.cancel && (
                <Button onClick={onCancel} className="_wg-dynamic-text" color="error" variant="outlined" autoFocus>
                  {popUpMessage.cancel}
                </Button>
              )}
              {popUpMessage.onOk && (
                <Button onClick={onOk} className="_wg-dynamic-text" color="error" variant="contained" autoFocus>
                  {popUpMessage.onOk}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
      )}
      {response.map((res, index) => {
        const workplace = res?.workplace[0]
        return (
          <Accordion className='resultaccordian'>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls='panel1bh-content'
              id='panel1bh-header'
              style={{ background: 'white' }}
            >
              <table>
                <tbody>
                  <tr>
                    <td style={{ width: '60px' }}>
                      <Avatar>
                        <ProfileIcon
                          type='HCO'
                          iconSX={{
                            width: '25px',
                            height: '25px'
                          }}
                        />
                      </Avatar>
                    </td>
                    <td style={{ width: '500px' }}>
                      {workplace.usualName}
                    </td>
                    <td>
                      <Tooltip disableFocusListener title="Subscribe" id="tooltip">
                        <IconButton aria-label="delete " className=" MuiIconButton-label" color="secondary" onClick={(event) => subcribeProfile(workplace, event)}>
                          <FileDownloadIcon className="text-muted" />
                        </IconButton>
                      </Tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </AccordionSummary>
            <AccordionDetails>

              <React.Fragment key={index}>
                <Typography>
                  <span className='text-muted'>
                    OneKey ID: {" "}
                  </span>
                  <span className='_wg-exclude'>
                    {workplace.workplaceEid}
                  </span>
                </Typography>
                {workplace.classificationCode != null && <Typography>
                  <span className='text-muted'>
                    Classification Code: {" "}
                  </span>
                  <span className='_wg-exclude'>
                    {workplace.classificationCode?.label} ({workplace.classificationCode?.code})
                  </span>
                </Typography>}

                {/* Identifiers */}
                {workplace.identifiers.length != 0 && <React.Fragment>
                  {workplace.identifiers.map((item, itemIndex) => <Typography key={itemIndex}>
                    <span className='text-muted'>
                      {item.label}: {" "}
                    </span>
                    <span className='_wg-exclude'>
                      {item.value}
                      {/* {item?.rank} */}
                    </span>
                  </Typography>)}
                </React.Fragment>}
              </React.Fragment>

              {/* Address */}
              <Accordion className='resultaccordian mt-2'>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls='panel1bh-content'
                  id='panel1bh-header'
                  sx={{ bgcolor: '#eeeeee' }}
                >
                  <Typography className='_wg-dynamic-text'>
                    Address
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {Object.keys(workplace.address).map((key) => {
                    const address = workplace.address[key]

                    return (<List
                      sx={{
                        width: '100%',
                        marginTop: 2
                      }}
                      component='nav'
                      aria-labelledby='nested-list-subheader'
                      key={key}
                    >
                      <ListItemButton
                        onClick={() =>
                          handleClick(`${index}-${key}`)
                        }
                        sx={{
                          bgcolor: '#eeeeee'
                        }}
                        id='list-address'
                        key={key}
                      >
                        <ListItemText>
                          <Typography>
                            {address.address.addressLongLabel} {address.address.postalTownReference.villageLabel}
                          </Typography>
                        </ListItemText>
                        {expanded[`${index}-${key}`] ? (
                          <RemoveIcon />
                        ) : (
                          <AddIcon />
                        )}
                      </ListItemButton>
                      <Collapse
                        in={
                          expanded[`${index}-${key}`] || false
                        }
                        timeout='auto'
                      >
                        <List component='div' disablePadding>
                          <ListItemButton
                            sx={{ pl: 4 }}
                            id='list-detail'
                          >
                            <ListItemText>
                              <Typography
                                className='_wg-dynamic-text'
                                key={'number'}>
                                <span className='text-muted'>
                                  Postal Code: {' '}
                                </span>
                                <span className='_wg-exclude'>
                                  {address.address.longPostalCode}
                                </span>
                              </Typography>

                              <Typography
                                className='_wg-dynamic-text'
                                key={'number'}>
                                <span className='text-muted'>
                                  Rank: {' '}
                                </span>
                                <span className='_wg-exclude'>
                                  {address.rank}
                                </span>
                              </Typography>
                              <Typography
                                className='_wg-dynamic-text'
                                key={'number'}>
                                <span className='text-muted'>
                                  Type: {' '}
                                </span>
                                <span className='_wg-exclude'>
                                  {address.typeCodeLabel}
                                </span>
                              </Typography>
                            </ListItemText>
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </List>)
                  })}

                </AccordionDetails>
              </Accordion>

              {/* Specialty */}
              {Object.values(workplace.speciality).length > 0 && <Accordion className='resultaccordian mt-2'>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls='panel1bh-content'
                  id='panel1bh-header'
                  sx={{ bgcolor: '#eeeeee' }}
                >
                  <Typography className='_wg-dynamic-text'>
                    Specialty
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {Object.keys(workplace.speciality).map((key) => {
                    const speciality = workplace.speciality[key]

                    return (<List
                      sx={{
                        width: '100%',
                        marginTop: 2
                      }}
                      component='nav'
                      aria-labelledby='nested-list-subheader'
                      key={key}
                    >
                      <ListItemButton
                        onClick={() =>
                          handleClick(`${index}-${key}sp`)
                        }
                        sx={{
                          bgcolor: '#eeeeee'
                        }}
                        id='list-speciality'
                        key={key}
                      >
                        <ListItemText>
                          <Typography>
                            {speciality.codeLabel}
                          </Typography>
                        </ListItemText>
                        {expanded[`${index}-${key}sp`] ? (
                          <RemoveIcon />
                        ) : (
                          <AddIcon />
                        )}
                      </ListItemButton>
                      <Collapse
                        in={
                          expanded[`${index}-${key}sp`] || false
                        }
                        timeout='auto'
                      >
                        <List component='div' disablePadding>
                          <ListItemButton
                            sx={{ pl: 4 }}
                            id='list-detail'
                          >
                            <ListItemText>
                              <Typography
                                className='_wg-dynamic-text'
                                key={'number'}>
                                <span className='text-muted'>
                                  Code: {' '}
                                </span>
                                <span className='_wg-exclude'>
                                  {speciality.code}
                                </span>
                              </Typography>

                              <Typography
                                className='_wg-dynamic-text'
                                key={'number'}>
                                <span className='text-muted'>
                                  Rank: {' '}
                                </span>
                                <span className='_wg-exclude'>
                                  {speciality.rank}
                                </span>
                              </Typography>
                            </ListItemText>
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </List>)
                  })}

                </AccordionDetails>
              </Accordion>}

            </AccordionDetails>
          </Accordion>
        )
      })}
    </>
  )
}

export default IqviaHcoResponse